import styled from 'styled-components';
import C from '@assets/themes/colors';

export const Root = styled.div`
  position: relative;
`

export const Box = styled.div`
  display: none;
  position: absolute;
  right: 16.3px;
  top: -185px;
  width: 297px;
  height: 170px;
  padding: 15px 15px 0 0;
  border-radius: 2px;
  background-color: rgba(18, 36, 66, 0.8);
  opacity: 0;
  transition: opacity 0.2s, max-height 0s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  z-index: 60;
  ${Root}:hover & {
    display: block;
    opacity: 1;
    max-height: 500px;
    transition-delay: 0.5s;
  }
`;

export const Text = styled.div`
  display: block;
  flex-grow: 0;
  margin: 0 0 16px 20px;
  font-family: Roboto;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #fff;
`;

export const Bold = styled.span`
  font-weight: bold;
`;